module.exports = __webpack_public_path__ + "static/media/error.406d70ca.svg";